type TikTokIconProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
};

export const TikTok = ({
  className = '',
  width = 20,
  height = 20,
}: TikTokIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        id="Vector"
        d="M11.4352 5.75956C11.3289 5.76985 11.2224 5.77528 11.1156 5.77577C9.945 5.77593 8.85308 5.18588 8.21188 4.20646V9.55031C8.21188 11.7316 6.4436 13.5 4.26219 13.5C2.08079 13.5 0.3125 11.7317 0.3125 9.55031C0.3125 7.3689 2.08079 5.60062 4.26219 5.60062C4.34462 5.60062 4.42527 5.60799 4.50632 5.6131V7.55954C4.42527 7.54981 4.34559 7.53498 4.26219 7.53498C3.14888 7.53498 2.24637 8.43748 2.24637 9.55079C2.24637 10.6641 3.14888 11.5666 4.26219 11.5666C5.37575 11.5666 6.35906 10.6893 6.35906 9.57584L6.37851 0.5H8.24058C8.41613 2.16981 9.76255 3.474 11.4371 3.59647V5.75956"
        fill="currentColor"
      />
    </svg>
  );
};
